// Shared styles first: CSS Modules imported by components must come after
// them to override the base classes they compose with.
import './styles/tokens.css';
import './styles/global.css';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App.js';

const container = document.getElementById('root');
if (!container) {
  throw new Error("L'element racine #root est introuvable dans index.html.");
}

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
